<div class="p-7 bg-lightest">
  <div class="flex md:inline">
    <h1 class="flex flex-row md:justify-center text-3xl md:text-5xl font-app-bold mb-5 md:mb-10 mt-5">
      {{ "loginPage.title" | translate }}
    </h1>
  </div>
  <div class="bg-white rounded-lg border-light border shadow-none px-5 pt-5 pb-10 lg:w-2/5 mt-4 md:mt-10 mx-auto">
    <h2 class="text-3xl font-app-bold text-darkest mb-5">
      {{ "loginPage.login" | translate }}
    </h2>
    <form [formGroup]="formGroup">
      <div>
        <label
          for="email"
          class="font-app-regular"
          >{{ "loginPage.email" | translate }}</label
        >
        <input
          pInputText
          type="email"
          id="email"
          formControlName="email"
          required
          class="w-full border-2 border-light mt-1 p-3"
          placeholder="Saisissez votre email"
          (blur)="emailBlurred = true"
          [ngClass]="{ 'border-severity-high': emailBlurred && email?.invalid }" />
        <small
          class="p-error"
          *ngIf="email?.touched && email?.invalid && (email?.errors)!['required']">
          {{ "loginPage.emailRequired" | translate }}
        </small>
        <small
          class="p-error"
          *ngIf="emailBlurred && email?.invalid && (email?.errors)!['pattern']">
          {{ "loginPage.emailInvalid" | translate }}
        </small>
        <div class="flex flex-col md:flex-row text-center md:text-left justify-between my-5">
          <span class="mb-3 md:mb-0 flex">
            <p-checkbox
              [binary]="true"
              inputId="checkSaveEmail"
              formControlName="checkSaveEmail"
              class="mr-2"></p-checkbox>
            <p class="text-dark">{{ "loginPage.rememberEmail" | translate }}</p>
          </span>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="flex justify-between items-center">
          <label
            for="password"
            class="mt-2 mb-1 font-app-regular"
            >{{ "loginPage.password" | translate }}</label
          >
          <p-overlayPanel #op>
            <ng-template pTemplate="content">
              <app-popup-password-template></app-popup-password-template>
            </ng-template>
          </p-overlayPanel>
          <button
            pButton
            class="block md:hidden text-dark"
            icon="pi pi-info-circle"
            (click)="op.toggle($event)"></button>
          <button
            pButton
            class="hidden md:block text-dark"
            icon="pi pi-info-circle"
            [pTooltip]="passwordTooltip"></button>
          <ng-template #passwordTooltip>
            <app-popup-password-template></app-popup-password-template>
          </ng-template>
        </div>
        <p-password
          id="password"
          formControlName="password"
          required
          class="w-full border-2 border-light p-3 rounded-lg font-app-regular mb-4"
          placeholder="Saisissez le mot de passe"
          (blur)="passwordBlurred = true"
          [toggleMask]="true"
          [feedback]="false"
          [autofocus]="false"
          [ngClass]="{
            'border-severity-high': passwordBlurred && password?.invalid,
          }" />
        <small
          class="p-error"
          *ngIf="password?.touched && password?.invalid && (password?.errors)!['required']">
          {{ "loginPage.passwordRequired" | translate }}
        </small>
        <small
          class="p-error"
          *ngIf="
            passwordBlurred && password?.invalid && ((password?.errors)!['minlength'] || (password?.errors)!['pattern'])
          ">
          {{ "loginPage.passwordInvalid" | translate }}
        </small>
      </div>
      <div class="mb-4">
        <a
          class="underline underline-offset-2 text-base font-app-regular"
          [routerLink]="['/mot-de-passe-oublie']"
          >{{ "loginPage.forgotPassword" | translate }}</a
        >
      </div>
      <div class="text-center md:text-left">
        <button
          pButton
          [label]="'loginPage.loginButton' | translate"
          type="submit"
          class="block text-center rounded-md py-3 px-5 bg-primary text-white w-full"
          [disabled]="formGroup.invalid || loading"
          [loading]="loading"
          (click)="login()"></button>
        <p-toast></p-toast>
      </div>
    </form>
  </div>
  <app-info-card
    [className]="'lg:w-2/5 mt-4 md:mt-10 mx-auto'"
    [title]="'loginPage.howToIdentify' | translate"
    [message]="'loginPage.identifyDescription' | translate"></app-info-card>
</div>
